import {
  Button,
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  MenuItem,
} from "@material-ui/core";
import { SelectValidator, TextValidator, ValidatorForm } from "react-material-ui-form-validator";

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useForm } from "../../../hooks/useForm";

import { AlertPagoTurno } from "../../turnos/consultaTurnos/AlertPagoTurno";
import { postPagoCoseguro } from "../../../actions/autorizaciones/Autorizaciones";
import { TURNOS_PERMISOS } from "../../../utils/permisos";
import { validarSoloUnPermiso } from "../../../helpers/permisos";
import { fetchMediosPago } from "../../../actions/cbos/medioPago";

export const ModalPagoCoseguro = (props) => {
  const dispatch = useDispatch();

  const {items: mediosPago} = useSelector( state => state.medioPago );
  const {permisos: permisosUser} = useSelector((state) => state.auth);

  const [openModalAlertPago, setOpenModalAlertPago] = useState(false);

  const initialValues = {
    nroLote: "",
    nroCupon: "",
    idMedioPago: ""
  };

  const [formValues, handleInputChange] = useForm(initialValues);

  const { nroLote, nroCupon, idMedioPago } = formValues;

  useEffect(() => {
    dispatch(fetchMediosPago());
  }, [dispatch]);

  const closeModalAlertPagoHandler = () => {
    setOpenModalAlertPago(false);
  };

  const onSubmitOpenAlertPagoHandler = () => {
    setOpenModalAlertPago(true);
  };

  const confirmarPagoCoseguro = () => {
    const data = {
      idSolicitud: props.idSolicitud,
      nroLote,
      nroCupon,
      idMedioPago,
      importeAbonado: props.importeCoseguros,
    };

    dispatch(postPagoCoseguro(data, closeModalAlertPagoHandler, props.closeModalHandler, props.handleCloseModalCoseguroImpresion, true,
      props.filtros
    ));
  };

  return (
    <Dialog
      fullWidth
      maxWidth={"sm"}
      open={props.open}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Formulario de Pago</DialogTitle>
      <DialogContent>
        <AlertPagoTurno
          open={openModalAlertPago}
          closeAlertModal={closeModalAlertPagoHandler}
          confirmButtonAction={confirmarPagoCoseguro}
        />
        <ValidatorForm onSubmit={onSubmitOpenAlertPagoHandler}>
          <Grid container spacing={2} style={{ width: "60%", margin: "auto" }}>
            <Grid item xs={12}>
              <Typography variant="h5" style={{ textAlign: "center" }}>
                Monto: ${props.importeCoseguros?.toFixed(2)}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" style={{ textAlign: "center" }}>
                {new Date().toLocaleDateString()}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <TextValidator
                fullWidth
                autoComplete="off"
                style={{ marginTop: 0 }}
                margin="normal"
                label="Nro. Lote"
                name="nroLote"
                value={nroLote}
                onChange={handleInputChange}
                validators={[
                  "required",
                  "matchRegexp:^[0-9]+$",
                  "minNumber: 1",
                  "maxNumber: 999999999",
                ]}
                errorMessages={[
                  "Campo obligatorio",
                  "Solo se permiten números positivos enteros",
                  "No puede ser 0",
                  "Solo se permite un maximo de 9 caracteres númericos",
                ]}
              />
            </Grid>
            <Grid item xs={12}>
              <TextValidator
                fullWidth
                autoComplete="off"
                style={{ marginTop: 0 }}
                margin="normal"
                label="Nro. Cupón"
                name="nroCupon"
                value={nroCupon}
                onChange={handleInputChange}
                validators={[
                  "required",
                  "matchRegexp:^[0-9]+$",
                  "minNumber: 1",
                  "maxNumber: 9999999999",
                ]}
                errorMessages={[
                  "Campo obligatorio",
                  "Solo se permiten números positivos enteros",
                  "No puede ser 0",
                  "Solo se permite un maximo de 10 caracteres númericos",
                ]}
              />
            </Grid>
            <Grid item xs={12}>
              <SelectValidator
                value={idMedioPago}
                style={{marginBottom: 35, marginTop: 5}}
                onChange={(e) => {
                  handleInputChange(e);
                }}
                label="Medio de Pago"
                name="idMedioPago"
                validators={["required"]}
                errorMessages={["El Medio de Pago es requerido"]}
                fullWidth
              >
                <MenuItem value="">
                  <em>Seleccione</em>
                </MenuItem>
                {validarSoloUnPermiso(permisosUser,
                  TURNOS_PERMISOS.PERMITE_SELECCIONAR_MEDIOS_PAGO_NO_HABILITADOS)
                  ?
                    mediosPago.map((item) => (
                      <MenuItem key={item.idMedioPago} value={item.idMedioPago}>
                        {item.descripcion}
                      </MenuItem>
                    ))
                  :
                    mediosPago.filter(s => s.habilitado).map((item) => (
                      <MenuItem key={item.idMedioPago} value={item.idMedioPago}>
                        {item.descripcion}
                      </MenuItem>
                    ))
                }
              </SelectValidator>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                margin: "1.5rem 0",
              }}
            >
              <Button
                style={{ margin: "0 2rem" }}
                color="secondary"
                variant="contained"
                onClick={props.closeModalHandler}
              >
                Cancelar
              </Button>
              <Button type="submit" color="primary" variant="contained">
                Confirmar Pago
              </Button>
            </Grid>
          </Grid>
        </ValidatorForm>
      </DialogContent>
    </Dialog>
  );
};
